import React, { createRef } from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DataTable from 'react-data-table-component';
import ExportToExcel from './ExporToExcel';

const columns =[
    {
        name: 'شرح حساب',
        selector: row => row.fullCode + " - " + row.title,
        sortable: true,
    },
    {
        name: 'گردش بدهکار',
        selector: row => row.bed,
        format: row => row.bed == null ? "" : row.bed.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
        sortable: true,
        center: true,
        width: "160px"
    },
    {
        name: 'گردش بستانکار',
        selector: row => row.bes,
        format: row => row.bes == null ? "" : row.bes.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
        sortable: true,
        center: true,
        width: "160px"
    },
    {
        name: 'مانده بدهکار',
        selector: row => row.remainBed,
        format: row => row.remainBed == null ? "" : row.remainBed.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
        sortable: true,
        center: true,
        width: "160px"
    },
    {
        name: 'مانده بستانکار',
        selector: row => row.remainBes,
        format: row => row.remainBes == null ? "" : row.remainBes.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ","),
        sortable: true,
        center: true,
        width: "160px"
    },
]





export default class ExploreReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'report',
            data: null,
            loading: true,
            id_to_remove: null,
            phrase: '',
            ids: [],
            filters: {},
            selectedGroup: [],
            selectedKol: [],
            selectedMoein: [],
            selectedTafsil: [],
            searchColumn: 'date',
            selectedColumns: [true, true, true, true, true],
            filterLevels: [0, 0, 0, 0],
            filterLevel: -1,
            clearSelectedRows: false,
            phrase1: '',
            phrase2: '',
            phrase3: '',
            phrase4: '',
            phrase5: '',

        };
        this.columnSettingsRef = createRef();
    }

    componentDidMount() {
        this.refreshData(null, 'explore');
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside); // حذف رویداد کلیک 
    }


    showGroup(_record) {
        var code = _record.fullCode;
        var level = 1;
        var v = false;
        if (this.state.filterLevel == -1) {
            v = true;
        }
        else {
            //start from this level and valid to show
            if (this.state.filterLevels[0] == level) v = true;

            var checkSide = 0;
            var checkerLevel = this.state.filterLevel;

            //پیدا کردن نقطه محوری در صورت انتخاب شدن از قبل
            for (var i = 0; i < checkerLevel; i++) {
                if (this.state.filterLevels[i] == level) checkerLevel = i;
            }

            if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
            if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;

            if (this.state.filterLevels[checkerLevel] == level && checkerLevel == 0) {
                v = true;
            }
            if (this.state.filterLevels[checkerLevel] == level && checkerLevel > 0) {
                checkerLevel--;
                if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
                if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;
            }
            if (checkSide == 1) {
            }
            if (checkSide == -1) {
                if (this.state.filterLevels[checkerLevel] == 2) {
                    this.state.selectedKol.forEach(f => {
                        if (f.fullCode.toString().substr(0, 2) == code) v = true;
                    });
                }
                if (this.state.filterLevels[checkerLevel] == 3) {
                    this.state.selectedMoein.forEach(f => {
                        if (f.fullCode.toString().substr(0, 2) == code) v = true;
                    });
                }
                if (this.state.filterLevels[checkerLevel] == 4) {
                    this.state.selectedTafsil.forEach(f => {
                        if (f.fullCode.toString().substr(0, 2) == code) v = true;
                    });
                }
            }
        }

        if (!this.isBlank(this.state.phrase1)) {
            if (!_record.title.includes(this.state.phrase1) && !_record.fullCode.toString().includes(this.state.phrase1) &&
                !_record.remainBes.toString().includes(this.state.phrase1) && !_record.remainBed.toString().includes(this.state.phrase1) &&
                !_record.bes.toString().includes(this.state.phrase1) && !_record.bed.toString().includes(this.state.phrase1)) v = false;
        }
        return v;
    }
    showKol(_record) {
        var code = _record.fullCode;
        var level = 2;
        var v = false;
        if (this.state.filterLevel == -1) {
            v = true;
        }
        else {
            //start from this level and valid to show
            if (this.state.filterLevels[0] == level) v = true;
            var checkSide = 0;
            var checkerLevel = this.state.filterLevel;

            //پیدا کردن نقطه محوری در صورت انتخاب شدن از قبل
            for (var i = 0; i < checkerLevel; i++) {
                if (this.state.filterLevels[i] == level) checkerLevel = i;
            }

            if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
            if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;

            if (this.state.filterLevels[checkerLevel] == level && checkerLevel == 0) {
                v = true;
            }
            if (this.state.filterLevels[checkerLevel] == level && checkerLevel > 0) {
                checkerLevel--;
                if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
                if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;
            }
            if (checkSide == 1) {
                if (this.state.filterLevels[checkerLevel] == 1) {
                    this.state.selectedGroup.forEach(f => {
                        if (code >= f.fullCode * 100 && code <= (f.fullCode * 100) + 99) v = true;
                    });
                }
            }
            if (checkSide == -1) {
                if (this.state.filterLevels[checkerLevel] == 3) {
                    this.state.selectedMoein.forEach(f => {
                        if (f.fullCode.toString().substr(0, 4) == code) v = true;
                    });
                }
                if (this.state.filterLevels[checkerLevel] == 4) {
                    this.state.selectedTafsil.forEach(f => {
                        if (f.fullCode.toString().substr(0, 4) == code) v = true;
                    });
                }
            }
        }

        if (!this.isBlank(this.state.phrase2)) {
            if (!_record.title.includes(this.state.phrase2) && !_record.fullCode.toString().includes(this.state.phrase2) &&
                !_record.remainBes.toString().includes(this.state.phrase2) && !_record.remainBed.toString().includes(this.state.phrase2) &&
                !_record.bes.toString().includes(this.state.phrase2) && !_record.bed.toString().includes(this.state.phrase2)) v = false;
        }

        return v;
    }
    showMoein(_record) {
        var code = _record.fullCode;
        var level = 3;
        var v = false;
        if (this.state.filterLevel == -1) {
            v = true;
        }
        else {
            //start from this level and valid to show
            if (this.state.filterLevels[0] == level) v = true;

            var checkSide = 0;
            var checkerLevel = this.state.filterLevel;

            //پیدا کردن نقطه محوری در صورت انتخاب شدن از قبل
            for (var i = 0; i < checkerLevel; i++) {
                if (this.state.filterLevels[i] == level) checkerLevel = i;
            }

            if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
            if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;

            if (this.state.filterLevels[checkerLevel] == level && checkerLevel == 0) {
                v = true;
            }
            if (this.state.filterLevels[checkerLevel] == level && checkerLevel > 0) {
                checkerLevel--;
                if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
                if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;
            }

            if (checkSide == 1) {
                if (this.state.filterLevels[checkerLevel] == 2) {
                    this.state.selectedKol.forEach(f => {
                        if (code >= f.fullCode * 100 && code <= (f.fullCode * 100) + 99) v = true;
                    });
                }
                if (this.state.filterLevels[checkerLevel] == 1) {
                    this.state.selectedGroup.forEach(f => {
                        if (code >= f.fullCode * 10000 && code <= (f.fullCode * 10000) + 9999) v = true;
                    });
                }
            }
            if (checkSide == -1) {
                if (this.state.filterLevels[checkerLevel] == 4) {
                    this.state.selectedTafsil.forEach(f => {
                        console.log(f.fullCode.toString().substr(0, 6));
                        if (f.fullCode.toString().substr(0, 6) == code) v = true;
                    });
                }
            }
        }

        if (!this.isBlank(this.state.phrase3)) {
            if (!_record.title.includes(this.state.phrase3) && !_record.fullCode.toString().includes(this.state.phrase3) &&
                !_record.remainBes.toString().includes(this.state.phrase3) && !_record.remainBed.toString().includes(this.state.phrase3) &&
                !_record.bes.toString().includes(this.state.phrase3) && !_record.bed.toString().includes(this.state.phrase3)) v = false;
        }

        return v;
    }
    showTafsil(_record) {
        var code = _record.fullCode;
        var moeinCode = parseInt(code.toString().substr(0, 6));
        var level = 4;
        var v = false;
        if (this.state.filterLevel == -1) {
            v = true;
        }
        else {
            //start from this level and valid to show
            if (this.state.filterLevels[0] == level) v = true;

            var checkSide = 0;
            var checkerLevel = this.state.filterLevel;

            //پیدا کردن نقطه محوری در صورت انتخاب شدن از قبل
            for (var i = 0; i < checkerLevel; i++) {
                if (this.state.filterLevels[i] == level) checkerLevel = i;
            }

            if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
            if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;

            if (this.state.filterLevels[checkerLevel] == level && checkerLevel == 0) {
                v = true;
            }
            if (this.state.filterLevels[checkerLevel] == level && checkerLevel > 0) {
                checkerLevel--;
                if (this.state.filterLevels[checkerLevel] < level) checkSide = 1;
                if (this.state.filterLevels[checkerLevel] > level) checkSide = -1;
            }

            if (checkSide == 1) {
                if (this.state.filterLevels[checkerLevel] == 3) {
                    this.state.selectedMoein.forEach(f => {
                        if (moeinCode == f.fullCode) v = true;
                    });
                }
                if (this.state.filterLevels[checkerLevel] == 2) {
                    this.state.selectedKol.forEach(f => {
                        if (moeinCode >= f.fullCode * 100 && moeinCode <= (f.fullCode * 100) + 9999) v = true;
                    });
                }
                if (this.state.filterLevels[checkerLevel] == 1) {
                    this.state.selectedGroup.forEach(f => {
                        if (moeinCode >= f.fullCode * 10000 && moeinCode <= (f.fullCode * 10000) + 999999) v = true;
                    });
                }
            }
            if (checkSide == -1) {

            }
        }

        if (!this.isBlank(this.state.phrase4)) {
            if (!_record.title.includes(this.state.phrase4) && !_record.fullCode.toString().includes(this.state.phrase4) &&
                !_record.remainBes.toString().includes(this.state.phrase4) && !_record.remainBed.toString().includes(this.state.phrase4) &&
                !_record.bes.toString().includes(this.state.phrase4) && !_record.bed.toString().includes(this.state.phrase4)) v = false;
        }

        return v;
    }
    showTrx(_record) {

        var fullCode = _record.moeinCode.toString() + _record.tafsilCode;
        var moeinCode = _record.moeinCode;
        var v = false;
        if (this.state.filterLevel == -1) {
            v = true;
        }
        else {
            var checkerLevel = this.state.filterLevel;

            if (this.state.filterLevels[checkerLevel] == 4) {
                this.state.selectedTafsil.forEach(f => {
                    if (fullCode == f.fullCode) v = true;
                });
            }
            if (this.state.filterLevels[checkerLevel] == 3) {
                this.state.selectedMoein.forEach(f => {
                    if (moeinCode == f.fullCode) v = true;
                });
            }
            if (this.state.filterLevels[checkerLevel] == 2) {
                this.state.selectedKol.forEach(f => {
                    if (moeinCode >= f.fullCode * 100 && moeinCode <= (f.fullCode * 100) + 9999) v = true;
                });
            }
            if (this.state.filterLevels[checkerLevel] == 1) {
                this.state.selectedGroup.forEach(f => {
                    if (moeinCode >= f.fullCode * 10000 && moeinCode <= (f.fullCode * 10000) + 999999) v = true;
                });
            }
        }

        if (!this.isBlank(this.state.phrase5)) {
            if (!_record.description.toString().includes(this.state.phrase5) && !_record.date.toString().includes(this.state.phrase5) &&
                !_record.refNumber.toString().includes(this.state.phrase5) && !_record.number.toString().includes(this.state.phrase5) &&
                !_record.bes.toString().includes(this.state.phrase5) && !_record.bed.toString().includes(this.state.phrase5) && !_record.documentId.toString().includes(this.state.phrase5)) v = false;
        }

        return v;

    }


    getGroupRecords() {
        var t = [];
        this.state.data.records.forEach(record => {
            if (record.accountType == 1 && this.showGroup(record)) t.push(record);
        });
        return t;
    }
    getKolRecords() {
        var t = [];
        this.state.data.records.forEach(record => {
            if (record.accountType == 2 && this.showKol(record)) t.push(record);
        });
        return t;
    }
    getMoeinRecords() {
        var t = [];
        this.state.data.records.forEach(record => {
            if (record.accountType == 3 && this.showMoein(record)) t.push(record);
        });
        return t;
    }
    getTafsilRecords() {
        var t = [];
        this.state.data.records.forEach(record => {
            if (record.accountType == 4 && this.showTafsil(record)) t.push(record);
        });
        return t;
    }
    getTransactionsRecords() {
        var t = [];
        this.state.data.transactions.forEach(record => {
            if (this.showTrx(record)) t.push(record);
        });

        return t;
    }


    getFilteredRecords = () => {
        const { phrase5, searchColumn } = this.state;
        const records = this.getTransactionsRecords();

        if (!phrase5) return records;

        return records.filter(record => {
            return record[searchColumn].toString().includes(phrase5);
        });
    };
    setFilterItem(selectedRows, level) {
        var preChecked = false;
        for (var i = 0; i < this.state.filterLevel; i++) {
            if (this.state.filterLevels[i] == level) {
                this.state.filterLevel = i;
                preChecked = true;
            }
        }
        if (this.state.filterLevel == -1) this.state.filterLevel++;
        if (this.state.filterLevels[this.state.filterLevel] != level) {
            if (this.state.filterLevels[this.state.filterLevel] == 0) this.state.filterLevels[this.state.filterLevel] = level;
            else {
                if (!preChecked) this.state.filterLevel++;
                this.state.filterLevels[this.state.filterLevel] = level;
            }
        }

        if (level == 1) {
            this.state.selectedGroup = [];
            if (this.isBlank(selectedRows)) {
                this.state.filterLevels[this.state.filterLevel] = 0;
                this.state.filterLevel--;
            }
            else selectedRows.forEach(r => this.state.selectedGroup.push(r));
            this.setState({ selectedGroup: this.state.selectedGroup });
        }
        if (level == 2) {
            this.state.selectedKol = [];
            if (this.isBlank(selectedRows)) {
                this.state.filterLevels[this.state.filterLevel] = 0;
                this.state.filterLevel--;
            }
            else selectedRows.forEach(r => this.state.selectedKol.push(r));
            this.setState({ selectedKol: this.state.selectedKol });
        }
        if (level == 3) {
            this.state.selectedMoein = [];
            if (this.isBlank(selectedRows)) {
                this.state.filterLevels[this.state.filterLevel] = 0;
                this.state.filterLevel--;
            }
            else selectedRows.forEach(r => this.state.selectedMoein.push(r));
            this.setState({ selectedMoein: this.state.selectedMoein });
        }
        if (level == 4) {
            this.state.selectedTafsil = [];
            if (this.isBlank(selectedRows)) {
                this.state.filterLevels[this.state.filterLevel] = 0;
                this.state.filterLevel--;
            }
            else selectedRows.forEach(r => this.state.selectedTafsil.push(r));
            this.setState({ selectedTafsil: this.state.selectedTafsil });
        }
    }
    removeFilters() {
        this.state.selectedGroup = [];
        this.state.selectedKol = [];
        this.state.selectedMoein = [];
        this.state.selectedTafsil = [];
        this.setState({
            clearSelectedRows: !this.state.clearSelectedRows,
            filterLevel: -1,
            filterLevels: [0, 0, 0, 0]
        })
    }
    renderFilters() {
        var filterLevels = this.state.filterLevels;
        var res = [];
        if (filterLevels[0] != 0) {
            var items = [];
            if (filterLevels[0] == 1) items = this.state.selectedGroup;
            if (filterLevels[0] == 2) items = this.state.selectedKol;
            if (filterLevels[0] == 3) items = this.state.selectedMoein;
            if (filterLevels[0] == 4) items = this.state.selectedTafsil;
            if (!this.isEmpty(items)) res.push(<span onClick={e => this.removeFilters()} className="hand badge rounded-pill bg-danger me-1">حذف فیلترها</span>);
            items.forEach(item => {
                if ((item.accountType == 1 && this.showGroup(item)) || (item.accountType == 2 && this.showKol(item)) ||
                    (item.accountType == 3 && this.showMoein(item)) || (item.accountType == 4 && this.showTafsil(item))) {
                    res.push(<span className="badge rounded-pill bg-info me-1">{item.title}</span>);
                }
            });
        }
        else
            return res;

        if (filterLevels[1] != 0) {
            let items = [];
            if (filterLevels[1] == 1) items = this.state.selectedGroup;
            if (filterLevels[1] == 2) items = this.state.selectedKol;
            if (filterLevels[1] == 3) items = this.state.selectedMoein;
            if (filterLevels[1] == 4) items = this.state.selectedTafsil;
            if (!this.isEmpty(items)) res.push(<span className="icon ni ni-back-ios me-1"></span>);
            items.forEach(item => {
                if ((item.accountType == 1 && this.showGroup(item)) || (item.accountType == 2 && this.showKol(item)) ||
                    (item.accountType == 3 && this.showMoein(item)) || (item.accountType == 4 && this.showTafsil(item))) {
                    res.push(<span className="badge rounded-pill bg-primary me-1">{item.title}</span>);
                }
            });
        }
        else
            return res;

        if (filterLevels[2] != 0) {
            let items = [];
            if (filterLevels[2] == 1) items = this.state.selectedGroup;
            if (filterLevels[2] == 2) items = this.state.selectedKol;
            if (filterLevels[2] == 3) items = this.state.selectedMoein;
            if (filterLevels[2] == 4) items = this.state.selectedTafsil;
            if (!this.isEmpty(items)) res.push(<span className="icon ni ni-back-ios me-1"></span>);
            items.forEach(item => {
                if ((item.accountType == 1 && this.showGroup(item)) || (item.accountType == 2 && this.showKol(item)) ||
                    (item.accountType == 3 && this.showMoein(item)) || (item.accountType == 4 && this.showTafsil(item))) {
                    res.push(<span className="badge rounded-pill bg-success me-1">{item.title}</span>);
                }
            });
        }
        else
            return res;

        if (filterLevels[3] != 0) {
            let items = [];
            if (filterLevels[3] == 1) items = this.state.selectedGroup;
            if (filterLevels[3] == 2) items = this.state.selectedKol;
            if (filterLevels[3] == 3) items = this.state.selectedMoein;
            if (filterLevels[3] == 4) items = this.state.selectedTafsil;
            if (!this.isEmpty(items)) res.push(<span className="icon ni ni-back-ios me-1"></span>);
            items.forEach(item => {
                if ((item.accountType == 1 && this.showGroup(item)) || (item.accountType == 2 && this.showKol(item)) ||
                    (item.accountType == 3 && this.showMoein(item)) || (item.accountType == 4 && this.showTafsil(item))) {
                    res.push(<span className="badge rounded-pill bg-secondary me-1">{item.title}</span>);
                }
            });
        }

        return res;
    }

    handleRowClick = (id) => {
        window.location.href = `/document/edit/${id}`;
    };
    handleCheckboxChange = (index) => {
        const newSelectedColumns = [...this.state.selectedColumns];
        newSelectedColumns[index] = !newSelectedColumns[index];
        this.setState({ selectedColumns: newSelectedColumns });
    }
    toggleColumnSettings = () => {
        this.setState(prevState => ({ showColumnSettings: !prevState.showColumnSettings }));
    }

    handleClickOutside = (event) => {
        if (this.columnSettingsRef.current && !this.columnSettingsRef.current.contains(event.target)) {
            this.setState({ showColumnSettings: false }); // بستن باکس در صورت کلیک خارج 
        }
    }




    renderForm() {

        //ستون های جدول گردش حساب که به علت تنظیمات ستون جدا شده اند
        const TrxColumns = [
            { name: 'تاریخ', selector: row => row.date, sortable: true, center: true, width: "130px" },
            { name: 'شرح سند', selector: row => row.description, sortable: true },
            {
                name: 'شماره سند', selector: row => row.number, sortable: true, center: true, width: "150px",
                cell: row => (
                    <div className="btn btn-dark" onClick={() => this.handleRowClick(row.documentId)}>
                        {row.number}
                    </div>
                ),
            },
            { name: 'بدهکار', selector: row => row.bed, format: row => row.bed == null ? "" : row.bed.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + ","), sortable: true, center: true, width: "150px" },
            { name: 'بستانکار', selector: row => row.bes, format: row => row.bes == null ? "" : row.bes.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + ","), sortable: true, center: true, width: "150px" }
        ];
        const visibleColumns = TrxColumns.filter((column, index) => this.state.selectedColumns[index]);


        return <div>
            <div className="card card-bordered card-preview">
                <div className="card-inner">
                    <div className="mb-2">{this.renderFilters()}</div>
                    <div className="fixed-tabs">
                        <ul className="nav nav-tabs mt-n3">
                            <li className="nav-item">
                                <a className="nav-link active" data-bs-toggle="tab" href="#group"><em className="icon ni ni-info"></em><span>گروه</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#kol"><em className="icon ni ni-list-round"></em><span>کل</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#moein"><em className="icon ni ni-wallet-alt"></em><span>معین</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#tafsil"><em className="icon ni ni-wallet-alt"></em><span>تفصیل 4</span></a>
                            </li>
                            {/*<li className="nav-item">*/}
                            {/*    <a className="nav-link" data-bs-toggle="tab" href="#tafsil"><em className="icon ni ni-wallet-alt"></em><span>تفصیل 5</span></a>*/}
                            {/*</li>*/}
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#trx"><em className="icon ni ni-calc"></em><span>گردش حساب</span></a>
                            </li>
                        </ul>
                    </div>
                    <div className="tab-content">
                        <div className="tab-pane active" id="group">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-inner-group">
                                        <div className="card-inner p-0">
                                            <div className="data-table-container-wrapper  custom-scroll">
                                                <div className="data-table-container ">
                                                    <DataTable
                                                        clearSelectedRows={this.state.clearSelectedRows}

                                                        columns={columns}
                                                        data={this.getGroupRecords()}
                                                        fixedHeader
                                                        selectableRows
                                                        noDataComponent="رکوردی برای نمایش وجودی ندارد"
                                                        direction="rtl"
                                                        onSelectedRowsChange={e => this.setFilterItem(e.selectedRows, 1)}
                                                        subHeader
                                                        subHeaderComponent={
                                                            <div className="d-flex justify-content-between align-items-center w-100">

                                                                <input defaultValue={this.state.phrase1} onChange={e => this.setState({ phrase1: e.target.value })} type="text" placeholder="جستجو بر اساس ..." className="form-control" style={{ width: "250px" }} />
                                                                <ExportToExcel data={this.getGroupRecords()} columns={columns}/>
                                                            </div>
                                                        }
                                                        persistTableHead
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane" id="kol">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-inner-group">
                                        <div className="card-inner p-0">
                                            <div className="data-table-container-wrapper custom-scroll">
                                                <div className="data-table-container  ">
                                                    <DataTable
                                                        clearSelectedRows={this.state.clearSelectedRows}
                                                        columns={columns}
                                                        data={this.getKolRecords()}
                                                        selectableRows
                                                        noDataComponent="رکوردی برای نمایش وجودی ندارد"
                                                        direction="rtl"
                                                        onSelectedRowsChange={e => this.setFilterItem(e.selectedRows, 2)}
                                                        subHeader
                                                        subHeaderComponent={
                                                        <div className="d-flex justify-content-between align-items-center w-100">
                                                            <input defaultValue={this.state.phrase2} onChange={e => this.setState({ phrase2: e.target.value })} type="text" placeholder="جستجو بر اساس ..." className="form-control" style={{ "width": "250px" }} />
                                                            <ExportToExcel data={this.getKolRecords()} columns={columns} />
                                                        </div>
                                                        
                                                        }
                                       
                                                        persistTableHead
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane" id="moein">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-inner-group">
                                        <div className="card-inner p-0">
                                            <div className="data-table-container-wrapper custom-scroll">
                                                <div className="data-table-container">
                                                    <DataTable
                                                        clearSelectedRows={this.state.clearSelectedRows}
                                                        columns={columns}
                                                        data={this.getMoeinRecords()}
                                                        selectableRows
                                                        noDataComponent="رکوردی برای نمایش وجودی ندارد"
                                                        direction="rtl"
                                                        onSelectedRowsChange={e => this.setFilterItem(e.selectedRows, 3)}
                                                        subHeader
                                                        subHeaderComponent={
                                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                                <input defaultValue={this.state.phrase3} onChange={e => this.setState({ phrase3: e.target.value })} type="text" placeholder="جستجو بر اساس ..." className="form-control" style={{ "width": "250px" }} />
                                                                <ExportToExcel data={this.getMoeinRecords()} columns={columns} />
                                                            </div>}
                                                        persistTableHead
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane" id="tafsil">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-inner-group">
                                        <div className="card-inner p-0">
                                            <div className="data-table-container-wrapper  custom-scroll">
                                                <div className="data-table-container">
                                                    <DataTable
                                                        clearSelectedRows={this.state.clearSelectedRows}
                                                        columns={columns}
                                                        data={this.getTafsilRecords()}
                                                        selectableRows
                                                        noDataComponent="رکوردی برای نمایش وجودی ندارد"
                                                        direction="rtl"
                                                        onSelectedRowsChange={e => this.setFilterItem(e.selectedRows, 4)}
                                                        subHeader
                                                        subHeaderComponent={
                                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                                <input defaultValue={this.state.phrase4} onChange={e => this.setState({ phrase4: e.target.value })} type="text" placeholder="جستجو بر اساس ..." className="form-control" style={{ "width": "250px" }} />
                                                                <ExportToExcel data={this.getTafsilRecords()} columns={columns} />
                                                            </div>}
                                                        persistTableHead
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane" id="trx">
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="card-inner-group">
                                        <div className="card-inner  p-0">
                                            <div className="data-table-container-wrapper  custom-scroll">
                                                <div className=" data-table-container">
                                                    <DataTable
                                                        columns={visibleColumns}
                                                        data={this.getFilteredRecords()}
                                                        noDataComponent={<div className="mt-3">رکوردی برای نمایش وجودی ندارد</div>}
                                                        direction="rtl"
                                                        subHeader
                                                        className=""
                                                        subHeaderComponent={
                                                            <div className="row w-100" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                <div className="row col-md-6">
                                                                    <div className="col-md-4">
                                                                        <div className="form-wrap me-2">
                                                                            <input
                                                                                defaultValue={this.state.phrase5}
                                                                                onChange={e => this.setState({ phrase5: e.target.value })}
                                                                                type="text"
                                                                                placeholder="جست و جو بر اساس"
                                                                                className="form-control"
                                                                                style={{ width: '150px', height: '40px', textAlign: 'center' }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4">
                                                                        <div className="form-wrap">
                                                                            <select
                                                                                onChange={e => this.setState({ searchColumn: e.target.value })}
                                                                                className="form-select form-select-lg "
                                                                                style={{ width: '150px', height: '40px', textAlign: 'center', fontSize: '0.8rem' }}
                                                                            >
                                                                                <option value="date">تاریخ</option>
                                                                                <option value="description">شرح سند</option>
                                                                                <option value="number">شماره سند</option>
                                                                                <option value="bed">بدهکار</option>
                                                                                <option value="bes">بستانکار</option>
                                                                            </select>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6 d-flex justify-content-end position-relative">
                                                                    <ExportToExcel data={this.getFilteredRecords()} columns={visibleColumns} />
                                                                    <button
                                                                        onClick={this.toggleColumnSettings}
                                                                        className={`m-1 btn btn-secondary bi bi-layout-three-columns ${this.state.showColumnSettings ? 'button-collapse' : ''}`}
                                                                        style={{
                                                                            height: '40px',
                                                                            fontSize: '1.1rem'
                                                                        }}
                                                                    >
                                                                    </button>

                                                                    {this.state.showColumnSettings && (
                                                                        <div className="position-absolute bg-white p-3 border custom-scroll"
                                                                            ref={this.columnSettingsRef}
                                                                            style={{
                                                                                top: '40px',
                                                                                right: '300px',
                                                                                width: '250px',
                                                                                maxHeight: '200px',
                                                                                maxWidth: '150px',
                                                                                overflowY: 'auto',
                                                                                zIndex: '1000',
                                                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                                                                            }} >
                                                                            {TrxColumns.map((column, index) => (
                                                                                <label key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="checkbox"
                                                                                            checked={this.state.selectedColumns[index]}
                                                                                            onChange={() => this.handleCheckboxChange(index)}
                                                                                            style={{ marginLeft: '10px' }}
                                                                                        />
                                                                                    {column.name}
                                                                                </label>
                                                                            ))}
                                                                        </div>
                                                                    )}    
                                                                </div>
                                                            </div>
                                                        }
                                                        persistTableHead
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmptyAnnualsOrCompanies(this.state.data.global) ? this.renderNoCompanyOrAnnualRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}